// extracted by mini-css-extract-plugin
export var deliveryRow = "_sh-a";
export var fixedHeight = "_sh-4";
export var freightLogo = "_sh-9";
export var fullWidth = "_sh-3";
export var priceColumn = "_sh-5";
export var radioSelected = "_sh-7";
export var radioUnselected = "_sh-6";
export var selectedOption = "_sh-2";
export var selectedOptionContainer = "_sh-1";
export var selection = "_sh-0";
export var tallSkeletonText = "_sh-8";